import ptMessages from '../locales/pt_BR.json';

const PtLang = {
  messages: {
    ...ptMessages,
  },
  locale: 'pt-BR',
};
export default PtLang;
